import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { hasAccess, getUserPermissions } from '@/core/rbac/hasAccess'
import { ROUTES } from '@/app/routes.constants'

type Props = {
  permissions?: string[]
  children: ReactNode
}

export function PermissionGate({ permissions, children }: Props) {
  if (hasAccess(permissions, getUserPermissions())) {
    return <>{children}</>
  }
  return <Navigate to={ROUTES.DASHBOARD} replace />
}
